import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import type { GroupPricingFragmentFragment } from '@/features/group-pricing/gql/_gen_/group-pricing.gql';

interface DeleteConfirmationDialogProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	group: GroupPricingFragmentFragment | null;
	onConfirm: () => Promise<void>;
	isLoading?: boolean;
}

export function DeleteConfirmationDialog({
	open,
	onOpenChange,
	group,
	onConfirm,
	isLoading = false,
}: DeleteConfirmationDialogProps) {
	return (
		<AlertDialog open={open} onOpenChange={onOpenChange}>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>Are you sure?</AlertDialogTitle>
					<AlertDialogDescription>
						This will permanently delete the group{' '}
						<strong>{group?.group_name || 'Untitled Group'}</strong>. This
						action cannot be undone.
					</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<AlertDialogCancel disabled={isLoading}>Cancel</AlertDialogCancel>
					<AlertDialogAction
						onClick={async (e) => {
							e.preventDefault();
							await onConfirm();
						}}
						disabled={isLoading}
						className='tw-bg-destructive hover:tw-bg-destructive/90'
					>
						{isLoading ? (
							<>
								<div className='tw-mr-2 tw-h-4 tw-w-4 tw-animate-spin tw-rounded-full tw-border-2 tw-border-white tw-border-t-transparent' />
								Deleting...
							</>
						) : (
							'Delete'
						)}
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	);
}
